<template>
  <DModal :showClose="false" :isBgOverlay="true" @close="$emit('close')">
    <div class="d-modal" slot="insertComponent">
      <div class="d-modal__header">
        <h2>{{ userName }}</h2>
        <div class="d-modal__header__right">
          <button class="do-bttn no-print" @click="print"><span class="icon-printer3"></span></button>
          <div class="icon__bg-circle no-print" @click="$emit('close')">
            <span class="icon-cross2"></span>
          </div>
        </div>
      </div>
      <div class="d-modal__content" id="printUserSalaryTable">
        <h4 class="only-print">{{ userName }}</h4>
        <div class="salarySubsPerfUserTable">
          <div v-for="table in tablesSorted" :key="table.rowKey">
            <button class="do-bttn do-bttn--custom-height do-copy-bttn no-print marg-1-bottom width-100"
                    @click="copyTableDayCounts(table, $event)"
                    :content="'Kopieret tabel for ' + table.title"
                    v-tippy="{
                                    onShow: hideTippy,
                                    trigger: 'manual',
                                    arrow: true,
                                    placement : 'top',
                                    zIndex: 2147483010
                                  }">
              Kopier tabel for <br> {{ table.title }}
            </button>
            <table class="d-table">
              <thead>
              <tr>
                <th>{{ table.title }}</th>
                <th>{{ table.minutes }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(date, index) in table.dates" :key="index">
                <td>{{ date.date }}</td>
                <td>{{ date.dayCount }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </DModal>
</template>

<script>
import moment from 'moment'
import DModal from '../common/DModal.vue'

export default {
  components: {DModal},
  props: {
    startDate: {
      default: () => moment()
    },
    endDate: {
      default: () => moment().add(3, 'days')
    },
    user: {
      default: null
    }
  },
  data () {
    return {
      tables: []
    }
  },
  computed: {
    userName () {
      return this.user && this.user.v_user_name ? this.user.v_user_name : ''
    },
    tablesSorted () {
      return this.tables.slice().sort((a, b) => {
        return a.title.localeCompare(b.title, 'da-DK')
      })
    }
  },
  methods: {
    createTables () {
      // Nulstil hvis component kan kaldes flere gange
      this.tables = []

      // Byg én tabel pr. kombination af employment_id + costCenter_code
      this.user.v_user_sums.forEach(sumType => {
        const rowKey = sumType.employment_id + '__' + (sumType.costCenter_code != null ? sumType.costCenter_code : 'noCC')
        const titlePrefix = sumType.costCenter ? '[' + sumType.costCenter + '] ' : ''
        const obj = {
          rowKey: rowKey,
          employmentId: sumType.employment_id,
          costCenterCode: sumType.costCenter_code || null,
          title: titlePrefix + sumType.employment_title,
          minutes: sumType.minutes_to_copy,
          dates: this.datesForTable(sumType.employment_id, sumType.costCenter_code || null)
        }
        this.tables.push(obj)
      })
    },

    datesForTable (employmentId, costCenterCodeOrNull) {
      function switchDotsAndCommas (s) {
        return s.replaceAll(/\.|,/g, match => (match === ',' ? '.' : ','))
      }

      const dates = []
      const startDate = moment(this.startDate).startOf('day')
      const endDate = moment(this.endDate).endOf('day')
      const daysDiff = endDate.diff(startDate, 'days')

      for (let i = 0; i <= daysDiff; i++) {
        const currentDate = startDate.clone().add(i, 'days')
        const formattedDate = currentDate.format('DD-MM-YYYY')
        const rawDate = currentDate.format('YYYY-MM-DD')

        const subDay = this.user.days.find(day => day.day === rawDate)
        let dayCount = null

        if (subDay) {
          // Find den præcise sum for både employment og cost center
          const theEmployment = subDay.v_sums.find(vSum => {
            if (vSum.employment_id !== employmentId) return false
            const a = vSum.costCenter_code
            const b = costCenterCodeOrNull
            // match på null=alle-uden-cc eller eksakt kode
            return a == null ? b == null : a === b
          })

          if (theEmployment) {
            dayCount = switchDotsAndCommas(JSON.parse(JSON.stringify(theEmployment.minutes_to_copy)))
          }
        }

        dates.push({ date: formattedDate, dayCount })
      }

      return dates
    },

    copyTableDayCounts (table, evt) {
      const dayCounts = table.dates
        .map(date => date.dayCount !== null && date.dayCount !== undefined ? date.dayCount : '')
        .join('\n')

      navigator.clipboard
        .writeText(dayCounts)
        .then(() => {
          evt.target._tippy.show()
        })
        .catch(err => {
          console.error('Failed to copy day counts for ' + table.title + ': ', err)
        })
    },

    hideTippy (tippyEl) {
      setTimeout(_ => {
        tippyEl.hide()
      }, 1000)
    },

    print () {
      const fileTitle = 'Vikarløn tabel ' + this.userName + ' - ' + moment(this.startDate).format('DD-MM-YYYY') + '_' + moment(this.endDate).format('DD-MM-YYYY') + ' • docendo.dk'
      const prtHtml = document.getElementById('printUserSalaryTable').innerHTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')]) {
        stylesHtml += node.outerHTML
      }
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      WinPrint.document.write('<!DOCTYPE html><html id="html-bg-white"><head><title>' + fileTitle + '</title>' + stylesHtml + '</head><body>' + prtHtml + '</body></html>')
      var afterPrint = () => {
        WinPrint.close()
      }
      WinPrint.onafterprint = afterPrint
      setTimeout(_ => {
        WinPrint.document.close()
        WinPrint.focus()
        WinPrint.print()
      }, 1000)
    }
  },
  mounted () {
    this.createTables()
  }
}
</script>

<style scoped>
.d-table {
  width: 200px;
  text-align: left;
  border: 1px solid #222;
  border-collapse: collapse;
}

.d-table thead th,
.d-table tbody td {
  border: 1px solid #222;
  background: #fff;
}

.d-table thead th:last-child,
.d-table tbody td:last-child {
  text-align: right;
}

.salarySubsPerfUserTable {
  display: flex;
  gap: 1rem;
  padding: 1rem;
}

.d-table tr {
  line-height: 20px;
}

.d-modal {
  min-width: 400px;
  width: auto;
}

.d-modal .d-modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 55px;
  border-radius: 0;
  margin-bottom: 0;
  text-align: left;
}

.d-modal__content {
  min-height: calc(100vh - 55px);
  max-height: calc(100vh - 55px);
  overflow-y: auto;
  background: #fff;
}

.user-list__user__table__header {
  background: #f6f9fc;
  border-top: 1px solid #e2e8f0;
  border-width: 1px 0;
}

.user-list__user__table__header th {
  padding: 0.5rem;
  text-align: left;
}

.d-modal__header__right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.do-bttn--custom-height {
  height: auto;
  line-height: 1.5;
}

@media print {
  .d-table {
    font-size: 8px;
  }

  .d-table tr {
    line-height: 12px;
  }

  .salarySubsPerfUserTable {
    padding: 0;
  }
}

</style>



// WEBPACK FOOTER //
// SalarySubsPerfUserTable.vue?14580508